<template>
    <div>
        <div class="ItemSearchSingleWrapper mx-auto mb-3" :class="{ disabled: disabled }">
            <div @mouseover="isHover = true;" @mouseleave="isHover = false;">
                <div v-if="isHover && !disabled" class="itemOverlay" @click="addItemHover();">
                    <div class="itemOverlayInner d-flex align-items-center flex-column justify-content-center">
                        <p>Add to forecast</p>
                        <div class="icon"><ForecastIcon :color="'#fff'" class="icon" v-if="isHover" /></div>
                    </div>
                </div>
                <div class="image-wrapper mx-auto"><ItemImage class="item-image" :item="item" :height="'120px'" :width="'120px'" /></div>
            </div>
        </div>
        <div>
            <ItemDescription
                :item="item"
                @clicked="addItem"
                :is-link-to-item-detail="false"
                :isShowPriceDetails="true"
                :is-disabled="disabled"
                :forecastWindows="forecastWindows"
            />
            <br />
        </div>
    </div>
</template>
<script>
import ItemImage from "@/components/forecasts/elements/ItemImage";
import ForecastIcon from "@/components/forecasts/elements/icons/ForecastIcon";
import ItemDescription from "@/components/forecasts/elements/ItemDescription";

export default {
    components: { ItemDescription, ForecastIcon, ItemImage },
    props: {
        item: {
            type: Object,
            required: true
        },
        forecastWindows: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isHover: false,
            hoverIcon: false
        };
    },
    methods: {
        addItemHover() {
            if (this.isHover) {
                this.addItem();
            }
        },
        addItem() {
            if (!this.disabled) {
                this.$emit("item-added");
            }
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../../css/forecasts";
.ItemSearchSingleWrapper {
    height: 120px;
    width: 120px;
}
.ItemSearchSingleWrapper.disabled {
    color: red;
}
.itemOverlay {
    height: 120px;
    width: 120px;
    background: $overlay_color;
    position: absolute;
    color: #fff;
    padding: 5px;
    z-index: 10;
    .itemOverlayInner {
        margin-left: auto;
        margin-right: auto;
        width: 120px;
        height: 120px;
        text-align: center;
    }
    .icon {
        cursor: pointer;
        height: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// ItemSearchSingle.vue?c027025e